<template>
    <component
        v-bind:is="upsellProductTileType"
        :product="product"
        :isMobile="isMobile">
    </component>
</template>

<script src='./product-tile.js'></script>
